import React, { useState, useEffect } from "react";
import { Button, Card, CardHeader, CardBody, CardTitle, Row, Col, Table } from "reactstrap";
import { useAuth } from "context/authContext.js";
import { msalInstance, loginRequest } from "authConfig.js";
import BeatLoader from "react-spinners/BeatLoader";
import { useAccessToken } from "context/tokenConfig.js";
import { baseurl } from "authConfig.js";
import { useClient } from "context/clientContext";
import ClientSelection from "components/SelectClient";
import { useHasChecked } from "context/hasCheckedContext";

const  SchemeDocuments = () => {

  const [isLoading, setIsLoading] = useState(false)
  const [documentsArray, setDocumentsArray] = useState([]);
  const { login } = useAuth();
  const { accessToken } = useAccessToken();
  const [data, setData] = useState([])
  const { hasChecked, setHasChecked } = useHasChecked()
  const { client } = useClient();

  const handleLogin = () => {
    msalInstance
      .loginPopup(loginRequest)
      .then(async (response) => {
        console.log("Login successful:", response);
        await login(); 
        window.location.reload();
      })      
      .catch(error => {
        console.error("Login error:", error);
      });
  };
  
  const getDocumentData = async () => {
    setIsLoading(true)
    try {
      const url = `${baseurl}/GetWebPresentationData?ClientId=${client}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setData(data);
        setIsLoading(false)
      } else {
        console.error('Failed to fetch document data', response.status);
        setIsLoading(false)
      }
    } catch (error) {
      console.error("Error in getDocumentData:", error);
      setIsLoading(false)
    }
  };

  useEffect(() => {
    if (accessToken && client !== -1) {
      getDocumentData();
    }

    if (client > 0) {
      setHasChecked(true)
    }
  }, [accessToken, client]);


  useEffect(() => {
    const typeOfFile = data.filter(item => item?.folderLabel === "SchemeDocuments")
    setDocumentsArray(typeOfFile);
  }, [data]);


  return (
    <>
      <div className="content">
      {isLoading ?
      <div style={{ paddingTop: '150px', display: "flex", justifyContent: "center" }}>
          <BeatLoader color={"#EC2B20"} size={35} loading={isLoading} />
      </div>
      :
      <>
        {accessToken === null ?
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "100px 50px 100px 50px" }}>
            <p style={{ fontSize: "20px" }}>
              Please log in to use this app
            </p>

            <Button
              onClick={handleLogin}
              style={{ backgroundColor: "#EC2B20", width: "25%" }}
              block
              className="btn-round"
            >
              Log In
            </Button>
          </div>
          :
            <>
  {client === 0 && !hasChecked ? (
    <ClientSelection />
  ) : (
    hasChecked && (
                    <>
            <Row>
              <Col md="12">
                <Card>
                  <CardHeader>
                    <CardTitle tag="h5" style={{ color: "#EC2B20" }}>List of Uploaded Scheme Documents</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <div className="content">
                      <Row>
                        <Col md="12">
                          <Card>
                            <CardBody>
                              <Table>
                                <thead className="text-primary">
                                  <tr style={{ color: "#2c2c2c" }}>
                                  {client === 0 ? 
                                        <th>Client Name</th>
                                        :
                                        null
                                    }
                                    <th>File Name</th>
                                    <th>File Stage</th>
                                    <th>Date Created</th>
                                    <th>Uploaded Date</th>
                                    <th>File Size (MB)</th>
                                  </tr>
                                </thead>
                                {documentsArray.length === 0 ? 
                                <p style={{ paddingTop: "20px"}}>No documents to show</p>
                                :
                                <tbody>
                                  {documentsArray?.map((j, index) =>
                                    <tr key={index}>
                                      {client === 0 ? 
                                        <td>{j.clientName}</td>
                                        :
                                        null
                                    }
                                      <td>{j.filename}</td>
                                      <td>{j.clientFileStage === "P" ? "Previous" : "Current"}</td>
                                      <td>{new Date(j?.fileCreatedDate).toLocaleDateString('en-GB')}</td>
                                      <td>{new Date(j?.uploadDate).toLocaleDateString('en-GB')}</td>
                                      <td>{j.fileSize}</td>
                                    </tr>
                                  )}
                                </tbody>
}
                              </Table>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            </>
))
}
            </>
}

          </>
        }

      </div>
    </>
  );
}

export default SchemeDocuments;
